import { Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, UrlSegment, Router } from '@angular/router';
import { AttestDialogComponent } from '../attest-dialog/attest-dialog.component';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { SessionStorageService } from '../services/session-storage.service';
import { EnvironmentService } from '../services/environment.service';
import { BackgroundDecorationComponent } from '../shared-components/background-decoration/background-decoration.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss'],
  imports: [
    BackgroundDecorationComponent,
    MatIconModule,
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
  ],
})
export class SsoComponent implements OnInit {
  private route = inject(ActivatedRoute);
  router = inject(Router);
  private rbs = inject(RightBridgeApiService);
  private envSvc = inject(EnvironmentService);
  private ss = inject(SessionStorageService);
  private dialog = inject(MatDialog);

  private environment;
  params = {
    session: null,
    org: null,
    app: null,
    profile: null,
    search: null,
    bridgeId: null,
    correlationId: null,
    video: null,
  };
  profileError = false;
  loginError = false;
  correlationID: string;
  traceID: string;
  queries = {
    correlationID: null,
    traceId: null,
  };
  urlItems: UrlSegment[];

  constructor() {
    const route = this.route;

    this.params = route.params['value'];
    this.queries = route.queryParams['value'];
    this.urlItems = route.url['value'];
  }

  ngOnInit() {
    this.environment = this.envSvc.get();

    let check = false;
    const paramsApp = this.params.app === 'se' ? this.params.app : 'rb';

    this.rbs
      .querySession(this.params.session, this.params.org, paramsApp, true)
      .subscribe({
        next: x => {
          if (x?.results) {
            check = +x.results > 0;
            if (check) {
              this.ss.set('session', this.params.session);
              this.rbs.getGlobals().subscribe(data => {
                this.ss.set('rights', data.results.user.rights);
                const rights = data.results.user.rights;
                const hasAttested = data.results.user.hasAttested;

                if (!hasAttested && rights.includes('LicenseAttest')) {
                  const dialogRef = this.dialog.open(AttestDialogComponent, {
                    panelClass: 'attest-dialog',
                  });
                  dialogRef.afterClosed().subscribe(result => {
                    if (result.data !== 'cancel') {
                      if (this.queries.correlationID) {
                        this.correlationID = this.queries.correlationID.replace(
                          '\\',
                          ''
                        );
                        this.profileError = true;
                      } else if (
                        this.urlItems.find(item => item.path === 'error')
                      ) {
                        this.correlationID = this.params.correlationId.replace(
                          '\\',
                          ''
                        );
                        this.profileError = true;
                      } else {
                        this.rbs.setSso(
                          this.params.org,
                          this.params.session,
                          this.params.app,
                          this.params.profile,
                          this.params.search,
                          this.params.bridgeId,
                          this.params.video
                        );
                      }
                    } else {
                      this.rbs.endSession().subscribe();
                    }
                  });

                  if (this.queries.traceId) {
                    this.traceID = this.queries.traceId;
                  }
                } else {
                  if (this.queries.correlationID) {
                    this.correlationID = this.queries.correlationID.replace(
                      '\\',
                      ''
                    );
                    this.profileError = true;
                  } else if (
                    this.urlItems.find(item => item.path === 'error')
                  ) {
                    this.correlationID = this.params.correlationId.replace(
                      '\\',
                      ''
                    );
                    this.profileError = true;
                  } else {
                    this.rbs.setSso(
                      this.params.org,
                      this.params.session,
                      this.params.app,
                      this.params.profile,
                      this.params.search,
                      this.params.bridgeId,
                      this.params.video
                    );
                  }

                  if (this.queries.traceId) {
                    this.traceID = this.queries.traceId;
                  }
                }
              });
            } else {
              this.profileError = true;
              this.loginError = true;
            }
          }
        },
        error: error => {
          console.error(error);
          this.profileError = true;
          this.loginError = true;
        },
      });
  }

  backToLanding() {
    this.router.navigate(['/']);
  }
}
